import React from 'react'
import { Link } from 'react-router-dom'

export default function TwoPartsBanner(props) {
    return (
        <div className="row pt-3 section-2-home-page">
            <div className={`col-sm-4 col-9 mx-auto order-sm-${props.sidesOrder[0]} order-${props.sidesOrder[1]} d-flex justify-content-center align-items-center px-0 side-one`}>
                <img src={props.sideImg} alt="comfy-chair" />
            </div>
            <div className={`col-sm col-9 mx-auto m${props.spacingSide}-sm-3 side-two order-sm-${props.sidesOrder[1]} order-${props.sidesOrder[0]} d-flex justify-content-start align-items-center`}>
                <div className="m-0 p-sm-0 py-5 ">
                    <h2 className='mb-3'>{props.title}</h2>
                    <h6 className='mt-2'>{props.tagline}</h6>
                    <Link to={`/${props.btnLink}`} className='btn rounded-0 header-home-page-btn'>
                        View Collection
                        <i className="ms-2 fa-solid fa-arrow-right-long"></i>
                    </Link>
                </div>
            </div>
        </div>
    )
}

